/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-this-in-sfc */

// ==============================================
// ==================Import======================
// ==============================================

// ==================Style&IMG===================
import './style.scss';

// ==================HighCharts===================
import Highcharts, { color } from 'highcharts/highstock';

// ==================React hook===================
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

// ===================Librairi joyride================
import Joyride, { STATUS } from 'react-joyride';

// ==================Components===================
import MultiplemetadataGrid from './MultipleMetadataGrid';
import MultipleMetadataMap from './MultipleMetadataMap';
import MultipleMetadataChart from './MultipleMetadataChart';
import MenuButton from '../MenuButton';
import ModalExportQuery from '../ModalExportQuery';
import Spinner3 from '../Spinner3';

// ==================Actions===================
import {
  fetchAdvancedSearch,
  saveLocationMultipleMetadata,
  setDataPercent,
  setModalNoData,
  setMultipleMetadataString,
  setSaveMarkerSelected,
  setSaveMultipleLinearOption,
  setSaveMultipleMetadataArray,
  setSaveMultipleMetadataArrayListName,
} from '../../actions/multipleMetadata';
import { setLoadingChart, setOpenTour } from '../../actions/site';
import { fetchFullSelectedStationData } from '../../actions/dataAPI';
import ModalNoData from '../ModalNoData';
import { globalConfig } from '../../configuration/config';
import ModalErrCo from '../ModalErrCo';

function MultipleMetadata() {
  // ===============hooks===============
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const multipleMetadatadaArray = useSelector(
    (state) => state.multipleMetadata.dataMultiple.multipleMetadataArray,
  );
  const loadingMap = useSelector((state) => state.site.map.loadingMap);
  const loadingChart = useSelector((state) => state.site.advancedSearch.chartLoading);
  const dataAPI = useSelector((state) => state.dataAPI.stations.list);
  const openTour = useSelector((state) => state.site.joyride.openTour);
  // const slug = useParams();
  const { '*': slug } = useParams();
  const decoded = decodeURIComponent(slug || '');
  const fullDataSelectedStation = useSelector(
    (state) => state.multipleMetadata.dataMultiple.fullDataSelectedStation,
  );
  const currentDate = useSelector((state) => state.metadata.data.currentDate);

  const multipleMetadataArrayListNames = useSelector(
    (state) => state.multipleMetadata.dataMultiple.multipleMetadataArrayListName,
  );

  const listStation = useSelector((state) => state.dataAPI.stations.list.data);

  const multipleGridRows = useSelector(
    (state) => state.multipleMetadata.dataMultiple.multipleGridRows,
  );

  const multipleMetadataStringModal = useSelector(
    (state) => state.multipleMetadata.dataMultiple.modalMultipleMetadataString,
  );

  const multipleLinearOptionsState = useSelector(
    (state) => state.multipleMetadata.dataMultiple.multipleLinearOptions,
  );

  const timeseriesPNG = useSelector((state) => state.multipleMetadata.dataMultiple.timeseriesPNG);

  const location = useLocation();
  const multipleMetadataLocation = useSelector((state) => state.multipleMetadata.location);

  // static step definition of tour of the interface
  const steps = [
    {
      target: '.btn-download',
      content: <p><strong>Step 1: </strong>Download the stations metadata in different format</p>,
      disableBeacon: true,
    },
    {
      target: '.btn-export',
      content:
  <p><strong>Step 2: </strong>
    Export the query for the command line tool and API request format
  </p>,
      disableBeacon: true,
    },
  ];
  // handler tour of he interface data transmission
  const handleJoyrideCallback = (data) => {
    const { status } = data;
    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

    if (finishedStatuses.includes(status)) {
      dispatch(setOpenTour(false));
    }
  };

  /** ******************************************************************************
  * temporalcharts function allow to display the temporal chart for several station
  ******************************************************************************* */
  function temporalcharts(data) {
    let mainchart;
    const order = [];
    const defaultcolor = '';
    const globalmarker = '';
    const hasPlotBand = false;
    const dataAvailabilityPercent = {};
    let firstDateRange = '';
    let lastDateRange = '';
    const titleRange = 'Data availability between station installation date and current date';
    const fromdateofrange = '';
    const endateofrange = '';
    const stationsSelectedArray = [];
    // prepare the data for the timeseries
    for (let i = 0; i < data.length; i += 1) {
      let firstDate = data[i].date_from;
      firstDate = firstDate.substring(0, 10);
      firstDateRange = firstDate;
      firstDate = Date.UTC(
        firstDate.substring(0, 4),
        firstDate.substring(5, 7) - 1,
        firstDate.substring(8, 10),
      );
      let lastDate = '';
      if (data[i].date_to === null) {
        lastDate = currentDate;
        lastDate = lastDate.substring(0, 10);
        lastDateRange = lastDate;
        lastDate = Date.UTC(
          lastDate.substring(0, 4),
          lastDate.substring(5, 7) - 1,
          lastDate.substring(8, 10),
        );
      }
      else {
        lastDate = data[i].date_to;
        lastDate = lastDate.substring(0, 10);
        lastDateRange = lastDate;
        lastDate = Date.UTC(
          lastDate.substring(0, 4),
          lastDate.substring(5, 7) - 1,
          lastDate.substring(8, 10),
        );
      }
      if (data[i].rinex_files_dates.length > 0) {
        const arraydate = data[i].rinex_files_dates[0].split(',');
        const referenceDate = [];
        const newStationObject = {};
        let newRefDate = [];
        newStationObject.name = multipleMetadataArrayListNames[i];
        newStationObject.keys = ['x', 'y', 'name'];
        const position = i;
        order.push(position);
        for (let j = 0; j < arraydate.length; j += 1) {
          if (j % 2 === 0) {
            newRefDate = [];
            newRefDate.push(Date.UTC(
              arraydate[j].slice(0, 4),
              arraydate[j].slice(5, 7) - 1,
              arraydate[j].slice(8, 10),
            )); // month start 0-11
            newRefDate.push(position);
            newRefDate.push('begindate');
            referenceDate.push(newRefDate);
          }
          else {
            newRefDate = [];
            newRefDate.push(Date.UTC(
              arraydate[j].slice(0, 4),
              arraydate[j].slice(5, 7) - 1,
              arraydate[j].slice(8, 10),
              11,
              59,
              59,
            )); // Date.UTC(year,month-1,day) start at 12h00
            newRefDate.push(position);
            newRefDate.push('enddate');
            referenceDate.push(newRefDate);
            newRefDate = [];
            newRefDate.push(Date.UTC(
              arraydate[j].slice(0, 4),
              arraydate[j].slice(5, 7) - 1,
              arraydate[j].slice(8, 10),
              12,
            ));
            newRefDate.push(null);
            referenceDate.push(newRefDate);
          }
        }
        newStationObject.data = referenceDate;
        stationsSelectedArray.push(newStationObject);
        // calcul data percent
        let nbFiles = 0;
        const listDate = data[i].rinex_files_dates[0].split(',');
        for (let k = 0; k < listDate.length; k += 2) {
          const dt = new Date(listDate[k].slice(0, 10));
          const end = new Date(listDate[k + 1].slice(0, 10));
          while (dt <= end) {
            nbFiles += 1;
            dt.setUTCDate(dt.getUTCDate() + 1);
          }
        }
        const dateDiff = lastDate - firstDate;
        const totalDays = dateDiff / (1000 * 3600 * 24);
        dataAvailabilityPercent[i] = `${((nbFiles * 100) / totalDays).toFixed(2)}%`;
        data[i].data_percent = dataAvailabilityPercent[i];
      }
    }
    // Plot the chart
    const options = {
      chart: {
        type: 'line',
        backgroundColor: 'rgb(255, 255, 255, 0.4)',
        borderRadius: '16px',
      },
      title: {
        text: titleRange,
        style: {
          fontWeight: 'bold',
          color: 'rgb(4, 139, 154)',
        },
      },
      legend: {
        enabled: false,
      },
      xAxis: {
        type: 'datetime',
        labels: {
          format: '{value:%e %b %Y}',
        },
      },
      yAxis: [{
        scrollbar: {
          liveRedraw: false,
          enabled: true,
        },
        min: 0,
        max: 6,
        categories: order,
        reversed: true,
        tickPositions: order,
        gridLineWidth: 0,
        dataGrouping: { enabled: false },
        showLastLabel: true,
        title: { text: '' },
        labels: {
          formatter: function () {
            const value = data[this.value].marker_long_name;
            return value !== 'undefined' ? value : this.value;
          },
        },
      },
      {
        opposite: true,
        linkedTo: 0,
        categories: order,
        gridLineWidth: 0,
        tickPositions: order,
        title: {
          text: '',
        },
        showLastLabel: true,
        labels: {
          enabled: true,
          formatter: function () {
            let value = data[this.value].data_percent;
            if (value === undefined) {
              value = '';
            }
            const tooltiptext = 'Percent of data between install date and current date';
            return `<span title="${tooltiptext}">${value}</span>`;
          },
          useHTML: true,
        },
      },
      ],
      plotOptions: {
        series: {
          animation: false,
          cursor: 'pointer',
          marker: {
            enabled: true,
            symbol: 'square',
          },
        },
      },
      tooltip: {
        formatter: function () {
          let tooltip;
          if (this.key === 'begindate') {
            tooltip = `<b>Start date: </b> ${Highcharts.dateFormat('%Y-%m-%d', this.x)}<br/><b>Marker: </b> ${this.series.name}`;
          }
          else if (this.key === 'enddate') {
            tooltip = `<b>End date: </b> ${Highcharts.dateFormat('%Y-%m-%d', this.x)}<br/><b>Marker: </b> ${this.series.name}`;
          }
          return tooltip;
        },
      },
      series: stationsSelectedArray,
      turboThreshold: 0,
    };
    dispatch(setSaveMultipleLinearOption(options));
    dispatch(setDataPercent());
  }

  // ================= useEffect ======================

  // display or update chart when data change
  useEffect(() => {
    if (fullDataSelectedStation.length > 0 && multipleMetadataStringModal.length > 0) {
      temporalcharts(fullDataSelectedStation);
    }
  }, [multipleMetadataStringModal, multipleGridRows]);

  useEffect(() => {
    if (Object.keys(multipleLinearOptionsState).length > 0) {
      dispatch(setLoadingChart(false));
    }
  }, [multipleLinearOptionsState]);

  // when page starting construct and launch query to collect data of list station
  useEffect(() => {
    let slugMarker = '';
    if (decoded.includes('marker=') && decoded.includes('&') === false) {
      slugMarker = decoded.substring(7);
    }
    else if (decoded.includes('marker=') && decoded.includes('&')) {
      slugMarker = decoded.substring(7, decoded.indexOf('&'));
    }
    slugMarker = slugMarker.toUpperCase();
    const endQueries = decoded.substring(decoded.indexOf('&'), decoded.length);
    // Case where the query contains marker=, without additional parameters and with a slug greater than or equal to 16, therefore with a station name of at least 9 characters
    if (decoded.includes('marker=') && listStation !== undefined && decoded.includes('&') === false && slugMarker.length >= 9) {
      dispatch(fetchFullSelectedStationData(decoded, globalConfig.config.REACT_APP_NODE_URL, globalConfig.config.REACT_APP_GLASS_API));
    }
    // Case where the query contains marker=, with additional parameters and with a station name less than 9 characters
    else if (decoded.includes('marker=') && listStation !== undefined && decoded.includes('&') && slugMarker.length < 9) {
      let queries = '';
      listStation.forEach((el) => {
        if (el.marker_long_name.startsWith(slugMarker)) {
          queries += `${el.marker_long_name},`;
        }
      });
      // dispatch(setMarkerFilesString(queries));
      if (queries.length === 9) {
        navigate(`/metadata/marker=${queries}/description`);
      }
      if (queries.length > 9) {
        dispatch(fetchFullSelectedStationData(`marker=${queries}${endQueries}`, globalConfig.config.REACT_APP_NODE_URL, globalConfig.config.REACT_APP_GLASS_API));
      }
      if (queries.length === 0) {
        dispatch(setModalNoData(true));
      }
    }
    // Case where the query contains marker=, with additional parameters and with a station name greater than or equal to 9 characters
    else if (decoded.includes('marker=') && listStation !== undefined && decoded.includes('&') && slugMarker.length >= 9) {
      dispatch(fetchFullSelectedStationData(decoded, globalConfig.config.REACT_APP_NODE_URL, globalConfig.config.REACT_APP_GLASS_API));
    }
    // Case where the query contains marker=, without additional parameters and with a slug less than 16 characters, therefore an incomplete station name
    else if (decoded.includes('marker=') && listStation !== undefined && decoded.includes('&') === false && slugMarker.length < 9) {
      let slugString = decoded.substring(7);
      slugString = slugString.toUpperCase();
      let queries = '';
      listStation.forEach((el) => {
        if (el.marker_long_name.startsWith(slugString)) {
          queries += `${el.marker_long_name},`;
        }
      });
      // dispatch(setMarkerFilesString(queries));
      if (queries.length === 9) {
        navigate(`/metadata/marker=${queries}/description`);
      }
      if (queries.length > 9) {
        dispatch(fetchFullSelectedStationData(`marker=${queries}`, globalConfig.config.REACT_APP_NODE_URL, globalConfig.config.REACT_APP_GLASS_API));
      }
      if (queries.length === 0) {
        dispatch(setModalNoData(true));
      }
    }
    // Case where the query does not contain marker=
    else if (decoded.includes('marker=') === false) {
      dispatch(fetchFullSelectedStationData(decoded, globalConfig.config.REACT_APP_NODE_URL, globalConfig.config.REACT_APP_GLASS_API));
    }
  }, [listStation]);

  useEffect(() => {
    if (decoded.includes('marker=') === false) {
      dispatch(fetchAdvancedSearch(decoded, globalConfig.config.REACT_APP_NODE_URL, globalConfig.config.REACT_APP_GLASS_API));
    }
    if (multipleMetadataLocation.length === 0) {
      dispatch(saveLocationMultipleMetadata(location.pathname));
    }
  }, []);

  useEffect(() => {
    if (multipleMetadataLocation.length !== 0 && multipleMetadataLocation !== location.pathname) {
      window.location.reload();
    }
  });

  // save name and data of station in the url
  useEffect(() => {
    if (fullDataSelectedStation.length > 0) {
      let multipleMetadataString = '';
      multipleMetadatadaArray.forEach((el) => {
        multipleMetadataString += `${el.marker_long_name},`;
      });
      multipleMetadataString = multipleMetadataString.substring(
        0,
        multipleMetadataString.length - 1,
      );
      dispatch(setMultipleMetadataString(multipleMetadataString));
    }
  }, [multipleMetadatadaArray]);

  useEffect(() => {
    if (decoded.includes('marker=') && decoded.includes('&') === false && decoded.length >= 16) {
      const multiplesMetadataArray = [];
      const multiplesMetadataArrayListNames = [];
      const slugString = decoded.substring(7);
      const slugArray = slugString.split(',');
      slugArray.forEach((slugElement) => {
        if (dataAPI.length !== 0) {
          dataAPI.data.forEach((dataElement) => {
            if (slugElement === dataElement.marker_long_name) {
              multiplesMetadataArray.push(dataElement);
              multiplesMetadataArrayListNames.push(dataElement.marker_long_name);
            }
          });
        }
      });
      if (multiplesMetadataArray.length !== 0) {
        dispatch(setSaveMultipleMetadataArray(multiplesMetadataArray));
        dispatch(setSaveMultipleMetadataArrayListName(multiplesMetadataArrayListNames));
      }
      dispatch(setLoadingChart(false));
    }
    else if (decoded.includes('marker=') && decoded.includes('&') === false && decoded.length < 16) {
      const multiplesMetadataArray = [];
      const multiplesMetadataArrayListNames = [];
      fullDataSelectedStation.forEach((elt) => {
        if (dataAPI.length !== 0) {
          dataAPI.data.forEach((dataElement) => {
            if (elt.marker_long_name === dataElement.marker_long_name) {
              multiplesMetadataArray.push(dataElement);
              multiplesMetadataArrayListNames.push(dataElement.marker_long_name);
            }
          });
        }
      });
      if (multiplesMetadataArray.length !== 0) {
        dispatch(setSaveMultipleMetadataArray(multiplesMetadataArray));
        dispatch(setSaveMultipleMetadataArrayListName(multiplesMetadataArrayListNames));
      }
    }
    else if (decoded.includes('&') && fullDataSelectedStation.length > 0) {
      const multiplesMetadataArray = [];
      const multiplesMetadataArrayListNames = [];
      fullDataSelectedStation.forEach((elt) => {
        if (dataAPI.length !== 0) {
          dataAPI.data.forEach((dataElement) => {
            if (elt.marker_long_name === dataElement.marker_long_name) {
              multiplesMetadataArray.push(dataElement);
              multiplesMetadataArrayListNames.push(dataElement.marker_long_name);
            }
          });
        }
      });
      if (multiplesMetadataArray.length !== 0) {
        dispatch(setSaveMultipleMetadataArray(multiplesMetadataArray));
        dispatch(setSaveMultipleMetadataArrayListName(multiplesMetadataArrayListNames));
      }
    }
    else if (fullDataSelectedStation.length > 0 && decoded.includes('&') === false) {
      const multiplesMetadataArray = [];
      const multiplesMetadataArrayListNames = [];
      fullDataSelectedStation.forEach((elt) => {
        if (dataAPI.length !== 0) {
          dataAPI.data.forEach((dataElement) => {
            if (elt.marker_long_name === dataElement.marker_long_name) {
              multiplesMetadataArray.push(dataElement);
              multiplesMetadataArrayListNames.push(dataElement.marker_long_name);
            }
          });
        }
      });
      if (multiplesMetadataArray.length !== 0) {
        dispatch(setSaveMultipleMetadataArray(multiplesMetadataArray));
        dispatch(setSaveMultipleMetadataArrayListName(multiplesMetadataArrayListNames));
      }
    }
  }, [fullDataSelectedStation, dataAPI]);

  const testStyle = {
    width: '100%',
    height: '100%',
    display: 'block',
    position: 'relative',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    color: 'grey',
    textDecoration: 'none',
  };

  const divStyle = {
    overflow: 'hidden',
    height: '255px',
    width: '100%',
  };

  return (
    <div>
      <Joyride
        run={openTour}
        steps={steps}
        callback={handleJoyrideCallback}
        continuous
        hideCloseButton
        scrollToFirstStep
        showProgress
        showSkipButton
        styles={{
          options: {
            zIndex: 10000,
            primaryColor: '#048b9a',
          },
        }}
      />

      {(loadingMap || loadingChart) && (
        <>
          <Spinner3 />
          <ModalNoData />
        </>
      )}

      {(!loadingMap && !loadingChart) && (
        <div className="container">
          <MenuButton />
          <div id="mulipleMetadataGrid">
            <MultiplemetadataGrid />
          </div>
          <div id="multipleMetadataMap">
            <MultipleMetadataMap />
            {(timeseriesPNG !== '' && (
              <div id="timeseries">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button className="nav-link active" id="uga-tab" data-bs-toggle="tab" data-bs-target="#uga" type="button" role="tab" aria-controls="uga" aria-selected="true">UGA</button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button className="nav-link" id="ingv-tab" data-bs-toggle="tab" data-bs-target="#ingv" type="button" role="tab" aria-controls="ingv" aria-selected="false">INGV</button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button className="nav-link" id="rob-tab" data-bs-toggle="tab" data-bs-target="#rob" type="button" role="tab" aria-controls="rob" aria-selected="false">ROB-EUREF</button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button className="nav-link" id="sgo-tab" data-bs-toggle="tab" data-bs-target="#sgo" type="button" role="tab" aria-controls="sgo" aria-selected="false">SGO-EPND</button>
                  </li>
                </ul>
                <div className="tab-content" id="myTabContent">
                  <div className="tab-pane fade show active" id="uga" role="tabpanel" aria-labelledby="uga-tab" style={divStyle}>
                    <a data-lightbox="timeseries" href={`https://gnssproducts.epos.ubi.pt/GlassFramework/webresources/products/time-series-plot/UGA-CNRS/${timeseriesPNG}`} target="_blank" style={testStyle} rel="noreferrer">
                      <img src={`https://gnssproducts.epos.ubi.pt/GlassFramework/webresources/products/time-series-plot/UGA-CNRS/${timeseriesPNG}`} style={testStyle} alt="No timeserie available from this Analysis/Combination Center" />
                    </a>
                  </div>
                  <div className="tab-pane fade" id="ingv" role="tabpanel" aria-labelledby="ingv-tab" style={divStyle}>
                    <a data-lightbox="timeseries" href={`https://gnssproducts.epos.ubi.pt/GlassFramework/webresources/products/time-series-plot/INGV/${timeseriesPNG}`} target="_blank" style={testStyle} rel="noreferrer">
                      <img src={`https://gnssproducts.epos.ubi.pt/GlassFramework/webresources/products/time-series-plot/INGV/${timeseriesPNG}`} style={testStyle} alt="No timeserie available from this Analysis/Combination Center" />
                    </a>
                  </div>
                  <div className="tab-pane fade" id="rob" role="tabpanel" aria-labelledby="rob-tab" style={divStyle}>
                    <a data-lightbox="timeseries" href={`https://gnssproducts.epos.ubi.pt/GlassFramework/webresources/products/time-series-plot/ROB-EUREF/${timeseriesPNG}`} target="_blank" style={testStyle} rel="noreferrer">
                      <img src={`https://gnssproducts.epos.ubi.pt/GlassFramework/webresources/products/time-series-plot/ROB-EUREF/${timeseriesPNG}`} style={testStyle} alt="No timeserie available from this Analysis/Combination Center" />
                    </a>
                  </div>
                  <div className="tab-pane fade" id="sgo" role="tabpanel" aria-labelledby="sgo-tab" style={divStyle}>
                    <a data-lightbox="timeseries" href={`https://gnssproducts.epos.ubi.pt/GlassFramework/webresources/products/time-series-plot/SGO-EPND/${timeseriesPNG}`} target="_blank" style={testStyle} rel="noreferrer">
                      <img src={`https://gnssproducts.epos.ubi.pt/GlassFramework/webresources/products/time-series-plot/SGO-EPND/${timeseriesPNG}`} style={testStyle} alt="No timeserie available from this Analysis/Combination Center" />
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div id="multipleMetadataChart">
            <MultipleMetadataChart />
          </div>
          <ModalExportQuery />
        </div>
      )}
      <ModalErrCo />
    </div>
  );
}

export default MultipleMetadata;
